import { render, staticRenderFns } from "./code_page.vue?vue&type=template&id=1dc55e7a&scoped=true"
import script from "./code_page.vue?vue&type=script&lang=js"
export * from "./code_page.vue?vue&type=script&lang=js"
import style0 from "./code_page.vue?vue&type=style&index=0&id=1dc55e7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc55e7a",
  null
  
)

export default component.exports